<template><!-- svgo-optimised -->
<svg class="icon icon__loading" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12H0C0 5.373 5.373 0 12 0s12 5.373 12 12h-2z"/></svg></template>